//トップページ　キービジュアルスライダー
import slick from 'slick-carousel';
export function idxFunc() {
  let indexPage = $('#indexTop').length;

  if (indexPage) {
    //ローディングアニメーション
    $('#loader-bg').delay(500).fadeOut(500);
    $('#loader').fadeOut(500);
    
    let loaderClose = function loaderClose() {
        $('#loader-bg').delay(500).fadeOut(500);//10秒たっても消えない時用
    }
    setTimeout(loaderClose, 5000);

    var videoElem = document.getElementById('movie01');
    videoElem.play();

    function sliderSetting() {
      var width = window.innerWidth;
      if (width <= 767) {
        $('.newsCardBox').not('.slick-initialized').slick({
          speed: 400,
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: false,
          infinite: false,
        });
      } else {
        $('.newsCardBox.slick-initialized').slick('unslick');
      }
    }

    // 初期表示時の実行
    sliderSetting();

    // リサイズ時の実行
    $(window).on('resize', function () {
      sliderSetting();
    });

    const navBtn = $('#navBtn');
    var modalVideoElem = document.getElementById('movie01');

    navBtn.on('click', function () {
      if (navBtn.hasClass('isOpen')) {
        modalVideoElem.pause();
      } else {
        modalVideoElem.play();
      }
    });
  }

}

/** スクロール一時禁止 **/
let scroll_control = function (e) {
  e.preventDefault();
}
let fixdScrollpos;
export function no_scroll() {
  document.addEventListener("mousewheel", scroll_control, {
    passive: false
  });
  document.addEventListener("touchmove", scroll_control, {
    passive: false
  });
}

/** スクロール解除 **/
export function return_scroll() {
  document.removeEventListener("mousewheel", scroll_control, {
    passive: false
  });
  document.removeEventListener('touchmove', scroll_control, {
    passive: false
  });
}

export function modalMovieFunc() {
  var modalVideoElem = document.getElementById('modalVideo01');
  var videoElem = document.getElementById('movie01');

  $("#playAll").on('click', function () {
    no_scroll();
    $("#modalMovie01").fadeIn();
    modalVideoElem.play();
    videoElem.pause();
  });

  $(".modalBack").on('click', function () {
    return_scroll();
    $(".overlay").fadeOut();
    modalVideoElem.pause();
    videoElem.play();
  });

  $('#modalMovieBtn').on('click', function () {
    return_scroll();
    $(".overlay").fadeOut();
    modalVideoElem.pause();
    videoElem.play();
  });
}